module.exports = __webpack_public_path__ + "assets/img/Super-Obvious-Landing-Page-w540.af25d8e3.webp";